module.exports = __webpack_public_path__ + "static/green_dragon_exales_poison-8cfbfd7015e089c22962cf797ca6c562.png";